import { render } from "./CancellationPolicy.vue?vue&type=template&id=1c7010e2"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__